/*
 * Copyright (c) 2020. Sayari LLC
 */

export const environment = {
    production: false,
    apiUrl: 'https://qaapi.getspeckles.com'
};
